<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  errors: { type: Object, default: () => ({}) },
  form: { type: Object, required: true },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
const methods = computed(() => [
  { value: 'especie', label: t('SALES.COMMISSION.PAYMENT_METHODS.ESPECIE') },
  { value: 'deposito', label: t('SALES.COMMISSION.PAYMENT_METHODS.DEPOSITO') },
  { value: 'ted_doc', label: t('SALES.COMMISSION.PAYMENT_METHODS.TED_DOC') },
  { value: 'pix', label: t('SALES.COMMISSION.PAYMENT_METHODS.PIX') },
  { value: 'cheque', label: t('SALES.COMMISSION.PAYMENT_METHODS.CHEQUE') },
]);
</script>

<template>
  <LaisCard :title="t('SALES.COMMISSION.COMPANY.TITLE')">
    <div class="grid gap-11">
      <div class="grid gap-4 sm:grid-cols-3">
        <LaisField
          :label="t('SALES.COMMISSION.FIELDS.GROSS')"
          :error="errors.gross_amount"
          required
        >
          <input
            :value="form.gross_amount"
            inputmode="decimal"
            class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
            :placeholder="t('SALES.COMMISSION.PLACEHOLDERS.MONEY')"
            @input="emit('update', 'gross_amount', $event.target.value)"
          />
        </LaisField>
        <LaisField
          :label="t('SALES.COMMISSION.FIELDS.DEDUCTION')"
          :error="errors.deduction"
        >
          <input
            :value="form.deduction"
            inputmode="decimal"
            class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
            :placeholder="t('SALES.COMMISSION.PLACEHOLDERS.MONEY')"
            @input="emit('update', 'deduction', $event.target.value)"
          />
        </LaisField>
        <LaisField :label="t('SALES.COMMISSION.FIELDS.NET')" required>
          <input
            :value="form.net_amount"
            disabled
            class="min-h-10 rounded-lais border border-lais-border bg-lais-bg-soft px-3 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-70"
          />
        </LaisField>
      </div>
      <div class="max-w-[409px]">
        <LaisField
          :label="t('SALES.COMMISSION.FIELDS.PAYMENT_METHOD')"
          :error="errors.payment_method"
          required
        >
          <select
            :value="form.payment_method"
            class="min-h-10 w-full rounded-lais border border-lais-border bg-white px-3 text-sm"
            @change="emit('update', 'payment_method', $event.target.value)"
          >
            <option value="">
              {{ t('SALES.COMMISSION.COMMON.SELECT') }}
            </option>
            <option
              v-for="method in methods"
              :key="method.value"
              :value="method.value"
            >
              {{ method.label }}
            </option>
          </select>
        </LaisField>
      </div>
    </div>
  </LaisCard>
</template>
